export default __webpack_public_path__ + "static/media/services-2.0b1feafe.jpg";